import { Action } from '@ngrx/store';
import { SettlementRate } from '../../model/SettlementRate';

export enum SettlementRateActionTypes {
  InitSettlementRates = 'InitSettlementRates',
  AddSettlementRate = 'AddSettlementRate',
  RemoveSettlementRate = 'RemoveSettlementRate',
  UpdateSettlementRate = 'UpdateSettlementRate',
}

export class InitSettlementRates implements Action {
  readonly type = SettlementRateActionTypes.InitSettlementRates;

  constructor(public payload: any) {
  }
}

export class AddSettlementRate implements Action {
  readonly type = SettlementRateActionTypes.AddSettlementRate;

  constructor(public payload: SettlementRate) {
  }
}

export class RemoveSettlementRate implements Action {
  readonly type = SettlementRateActionTypes.RemoveSettlementRate;

  constructor(public payload: string) {
  }
}

export class UpdateSettlementRate implements Action {
  readonly type = SettlementRateActionTypes.UpdateSettlementRate;

  constructor(public payload: SettlementRate) {
  }
}

export type SettlementRateActions =
  InitSettlementRates |
  AddSettlementRate |
  RemoveSettlementRate |
  UpdateSettlementRate;
